/**
 * Theme v2 — motion tokens.
 *
 * Two complementary scales: how long it takes (`duration`) and how it
 * feels (`easing`). Components compose them in a CSS transition:
 *   transition: opacity ${motion.duration.base} ${motion.easing.standard};
 *
 * Durations match the prototype's `motionDurationMid: 0.2s` /
 * `motionDurationSlow: 0.3s` (now named semantically). Easings follow
 * Material-style standard curves — proven good for micro-interactions.
 */
export const motion = {
  duration: {
    instant: "0ms",
    fast: "100ms", // hover/focus tint flips, small reveals
    base: "200ms", // default — buttons, tab switches, panel slides
    slow: "300ms", // modals, drawers, larger entrances
  },

  easing: {
    // Material's "standard" — slight overshoot-free ease in + out. Use
    // for most transitions where direction isn't a defining quality.
    standard: "cubic-bezier(0.4, 0, 0.2, 1)",
    // Decelerate — starts fast, ends slow. Good for elements entering
    // (something appearing from off-screen settles gently).
    out: "cubic-bezier(0, 0, 0.2, 1)",
    // Accelerate — starts slow, ends fast. Good for elements leaving.
    in: "cubic-bezier(0.4, 0, 1, 1)",
  },
} as const;

export type Motion = typeof motion;
